import UpdatePaymentMethodContainer from './UpdatePaymentMethodContainer';
export default UpdatePaymentMethodContainer;
